const gsap = window.gsap;

if (gsap !== undefined) {
  gsap.utils.toArray(".section-img-wrapper").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const y = (self.progress - 0.5) * 50;
        gsap.set(el, { "--y": y + "px" });
      },
    });
  });
}
